import React from "react";

import instaImg1 from "../../assets/img/footer/thumb-1-1.png";

const OffCanvasInsta = () => {
  return (
    <div className="it-offcanvas-insta d-none d-xl-block mt-50">
      <div className="row gx-10">
        <div className="col-xl-3 mb-10">
          <div className="it-offcanvas-insta-item">
            <a href="#">
              <img className="w-100" src={instaImg1} alt="" />
            </a>
          </div>
        </div>
        <div className="col-xl-3 mb-10">
          <div className="it-offcanvas-insta-item">
            <a href="#">
              <img className="w-100" src={instaImg1} alt="" />
            </a>
          </div>
        </div>
        <div className="col-xl-3 mb-10">
          <div className="it-offcanvas-insta-item">
            <a href="#">
              <img className="w-100" src={instaImg1} alt="" />
            </a>
          </div>
        </div>
        <div className="col-xl-3 mb-10">
          <div className="it-offcanvas-insta-item">
            <a href="#">
              <img className="w-100" src={instaImg1} alt="" />
            </a>
          </div>
        </div>
        <div className="col-xl-3 mb-10">
          <div className="it-offcanvas-insta-item">
            <a href="#">
              <img className="w-100" src={instaImg1} alt="" />
            </a>
          </div>
        </div>
        <div className="col-xl-3 mb-10">
          <div className="it-offcanvas-insta-item">
            <a href="#">
              <img className="w-100" src={instaImg1} alt="" />
            </a>
          </div>
        </div>
        <div className="col-xl-3 mb-10">
          <div className="it-offcanvas-insta-item">
            <a href="#">
              <img className="w-100" src={instaImg1} alt="" />
            </a>
          </div>
        </div>
        <div className="col-xl-3 mb-10">
          <div className="it-offcanvas-insta-item">
            <a href="#">
              <img className="w-100" src={instaImg1} alt="" />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};
export default OffCanvasInsta;
